import styled, { createGlobalStyle } from 'styled-components';

export const HeaderGlobalStyle = createGlobalStyle`
    .entete {
        margin: 0;
    }
`;

export const DirectoryPageContainer = styled.main`
    #annuaire-menu-alphabet {
        justify-content: space-between;
    }
    #annuaire-menu-alphabet a,
    #annuaire-menu-alphabet b {
        padding: 0.5em;
        text-decoration: none;
    }
    #annuaire-menu-alphabet a:hover {
        text-decoration: underline;
    }
    .annuaire-menu-alphabet-hr {
        margin: 40px 0 20px;
    }
    #annuaire-menu-alphabet + .annuaire-menu-alphabet-hr {
        margin: 20px 0 40px;
    }

    @media screen and (max-width: ${props => props.theme.mobile}) {
        .cmt-ca-marche {
            padding-bottom: 30px;
        }
        .annuaire-menu-alphabet-hr {
            width: 100%;
        }
    }

    .grid-4-small-2 > * {
        margin-bottom: 30px;
    }

    .conteneur-voir-plus {
        text-align: center;
    }

    @media screen and (max-width: ${props => props.theme.mobile}) {
        .conteneur-voir-plus .bt {
            display: block;
            margin: 0 auto;
            width: 100%;
            max-width: 280px;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/directory/DirectoryPageStyle.js